module.exports = __webpack_public_path__ + "83b46028185b9f654882eb8da053342a.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/projekte/sehnsucht.jpg
// module id = 674
// module chunks = 0